module.exports = __webpack_public_path__ + "static/media/Phone.30a946ec.svg";